export * from '@lskjs/log/cli';
export { default } from '@lskjs/log/cli';
